
import React from 'react';
import { Line,Bar,Pie,Doughnut } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    BarElement,
    ArcElement,
    
    Title,
    Tooltip,
    Legend,
} from 'chart.js';

// Register the components you want to use
ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    BarElement,
    ArcElement,
    Title,
    Tooltip,
    Legend
);

const PieChart = ({values,labels,backgroundColors,legend=false}) => {
    const data =  {
        labels:labels?.length>0?labels: [
            'Facebook',
            'Instagram',
            'LinkedIn'

          ],
          datasets: [{
            label: '',
            data:values?.length>0?values: [1,1,1],
            backgroundColor:backgroundColors?.length>0?backgroundColors: [
              '#D3A4FF',
              '#FFB1E0',
              '#95F3FA',
            
            ],
            hoverOffset: 4
          }]
    }

    const options = {
        responsive: true,
        maintainAspectRatio: true,
        scales: {
         
            
        },
        plugins: {
            legend: {
                display: legend ,
                position:'bottom'
            }
        }

    }


 return <Pie  data={data} options={options}  height={"50%"} />;


};

export default PieChart;
